import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=265429fa&scoped=true&"
import script from "./InfoDialog.vue?vue&type=script&lang=ts&"
export * from "./InfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265429fa",
  null
  
)

export default component.exports